import React, { useState ,useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch} from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine ,RiCheckboxCircleFill,RiCloseCircleFill} from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import NavBtn from '../Nav/NavBtn';
import { Image } from '../img';
import {Utility} from '../Utility/Utility';

// import { RiLogoutBoxLine } from "react-icons/ri";

const Home = (props) => {
    const currentLocation = useLocation();
    
    const dispatch=useDispatch();
    
    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches',matches)
    const rightIconAry=[
        {
            icon:'How_dark',
            label: 'How to access OLE',
            path:'/how_to_access_ole',
        },
        {
            icon:'Dashboard_light',
            label: 'Dashboard',
            path:'/ashboard'
        },
        {
            icon:'Course_light',
            label: 'Course Page',
            path:'/course_page',
        },
        {
            icon:'Attendance_light',
            label: 'Taking Attendance',
            path:'/taking_attendance'
        },
        {
            icon:'Assignment_light',
            label: 'Assignment',
            path:'/assignment',
        },
        {
            icon:'Zoom_light',
            label: 'Zoom Recording',
            path:'/zoom_recording',
        },
        {
            icon:'Teaching_light',
            label: 'Teaching Tools',
            path:'/teaching_tools',
        }
    ]


    return (
        <div className='MainContainer'>
            <Header/>
            <div className={'MainContent'}>
                <img className='MainContentFixBottomImageOnly' src={Image.inner_pages_bg1} alt='banner'/>
                <div className='MainContentFixBottomLine'></div>
                <div className={'MainContentBox'}>
                    <img className="MainContentTopImage" src={Image.Sub_how} alt='banner' />
                    <div className="MainContentTopContain">
                        <span className="MainContentTopText">How to Access OLE</span>
                    </div>
                    <div className={"MainContentMiddleDetail"} >
                        <div style={{    verticalAlign: 'middle',display: 'table-cell'}}>
                        <p>To access the OLE, please go to</p>
                        
                        <a href='https://ole.hkmu.edu.hk/' target="_blank" style={{color:'#F26F12'}}>https://ole.hkmu.edu.hk/</a>
                        <br/><br/>
                        <span className='subtitle'>Username: </span>
                        <br/>
                        Full-time staff: [Your HKMU username]<br/>
                        e.g. if your HKMU email is abc@hkmu.edu.hk, your username will be ‘abc’.
                        <br/><br/>
                        <span>
                        A full-time staff member may also serve as a tutor in certain courses. In such cases, they will also be assigned a tutor account in the format ‘t123456’, where the six digits correspond to their staff number.
                        </span>
                        <br/><br/>
                        <span className='subtitle'>Password: </span>
                        <br/>
                        <span><a href="https://www.hkmu.edu.hk/ito/staff-services/create-your-single-password-staff/" target="_blank">Your HKMU single password</a></span>
                        </div>
                    </div>
                    <NavBtn  nextItem='/dashboard'/>
                </div>
                
            </div>
            
            
        </div>
    )
};
  

const mapStateToProps =(state)=> {
    const {userInfo}=state;
    return {
        userInfo
    }
}

// export default Home;
export default connect(mapStateToProps)(Home);